import { NavLink } from "react-router-dom";
import Logo from "./Logo";
import {
  LayoutDashboard,
  Package,
  Box,
  CheckCircle2,
  Cog,
  Mic,
  MessageCircle,
  Settings2,
  Menu,
  X,
} from "lucide-react";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/raw-materials", label: "Raw Materials", icon: Package },
  { to: "/packaging", label: "Packaging", icon: Box },
  { to: "/finished-goods", label: "Finished Goods", icon: CheckCircle2 },
  { to: "/manufacturing", label: "Manufacturing", icon: Cog },
  { to: "/voice-import", label: "Voice Import", icon: Mic },
  { to: "/chat", label: "Stock Chat", icon: MessageCircle },
  { to: "/settings", label: "Settings", icon: Settings2 },
];

interface Props {
  collapsed: boolean;
  onToggle: () => void;
}

export default function Sidebar({ collapsed, onToggle }: Props) {
  return (
    <>
      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/40 z-20 lg:hidden"
          onClick={onToggle}
        />
      )}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-30 flex flex-col bg-navy-900 border-r border-navy-700/60 transition-all duration-300 ${
          collapsed ? "-translate-x-full lg:translate-x-0 lg:w-16" : "w-64"
        }`}
      >
        <div className="flex items-center h-16 px-4 border-b border-navy-700/60 gap-3">
          <button
            onClick={onToggle}
            className="p-2 rounded-lg hover:bg-navy-700 text-metallic-silver hover:text-white transition-colors"
          >
            {collapsed ? <Menu className="w-5 h-5" /> : <X className="w-5 h-5" />}
          </button>
          <Logo collapsed={collapsed} />
        </div>

        <nav className="flex-1 py-4 space-y-1 px-2 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => {
                if (window.innerWidth < 1024) onToggle();
              }}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-citilux-blue-600/20 text-citilux-blue-400 border border-citilux-blue-500/30"
                    : "text-metallic-silver hover:bg-navy-700 hover:text-white border border-transparent"
                } ${collapsed ? "justify-center lg:justify-center px-0" : ""}`
              }
            >
              <item.icon className="w-5 h-5 shrink-0" />
              {!collapsed && <span className="truncate">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-navy-700/60">
          {!collapsed && (
            <p className="text-[10px] text-metallic-silver/40 uppercase tracking-widest text-center">
              Mavelux Ledger v1
            </p>
          )}
        </div>
      </aside>
    </>
  );
}
